// extracted by mini-css-extract-plugin
module.exports = {"switch":"theme-switch_switch__FvTYY","thumb":"theme-switch_thumb__smQPz","track":"theme-switch_track__KSdRP"};